import { CRUDBasicListComponent } from '../crud-basic-list/crud-basic-list.component';
//import { CRUDBasicListComponent_Template, CRUDBasicListComponent } from '../crud-basic-list/crud-basic-list.component'; // HTML Template Plugins
//import { InventurListComponent_Template } from './#fileName#-list.component.include_template'; // HTML Template Plugins

import { Component, OnInit, Inject, forwardRef, Injector, OnDestroy } from '@angular/core';
import { AppComponent } from '../app.component';

//import { IInventur } from '../_interfaces/#fileName#';
import { InventurService } from '../_services/inventur.service';
import { DienstleisterPipe } from '../_pipes/dienstleister.pipe';
import { DatumFormatPipe, DatumOhneZeitPipe } from '../_pipes/datum-ohne-zeit.pipe';
import { DatumPipe } from '../_pipes/datum.pipe';
import { BehaelterPipe } from '../_pipes/behaelter.pipe';
import { BehaelterService } from '../_services/behaelter.service';
import { HerstellerService } from '../_services/hersteller.service';
import { HerstellerPipe } from '../_pipes/hersteller.pipe';
import { IInventur } from '../_interfaces/inventur';
import { Subscriber, Subscription } from 'rxjs';
import { NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-inverturen-list',
    //templateUrl: '../crud-basic-list/crud-basic-list.component.html',
    templateUrl: './inventur-list.component.html',
    //template: `${CRUDBasicListComponent_Template || ''}${InventurListComponent_Template}`,  // HTML Template Plugins
    styleUrls: ['../crud-basic-list/crud-basic-list.component.css'],
    host: {
        '(window:keydown)': 'hotkeys($event)',
        '(window:resize)': 'sizeTable()'
    }
})
export class InventurListComponent extends CRUDBasicListComponent implements OnInit, OnDestroy {
    pageTitle: string = this.translate.instant("Inventuren", true);
    CRUDItemKurzform: string = "Inventur";
    CRUDItemButtonTitleNeu: string = this.translate.instant("Neue Inventur", true);
    CRUDItemBezeichnungSingularCapitalized: string = "Inventur";
    CRUDItemBezeichnungPluralCapitalized: string = "Inventuren";
    CRUDItemBezeichnungSingular: string = "inventur";
    CRUDItemBezeichnungPlural: string = "inventuren";
    CRUDItemHelpTopic: string = "Inventur";
    CRUDItemRouteSingular: string = "inventur";
    CRUDItemRoutePlural: string = "inventuren";

    CRUDLazyLoad: boolean = true; // "Pseudo"-Lazyload
    CRUDLazyLoadVirtualRowHeight: number = 35; // bei lazyLoading / virtualScroll muss die TR eine fixe Grösse haben, sonst Scrolling ungenau! - Hier gewünschte Höhe in px angeben

    dienstleisterPipe: DienstleisterPipe = new DienstleisterPipe(this._app);
    datumOhneZeitPipe: DatumOhneZeitPipe = new DatumOhneZeitPipe();
    //datumFormatPipe: DatumFormatPipe = new DatumFormatPipe();
    datumPipe: DatumPipe = new DatumPipe();
    behaelterService: BehaelterService = null;
    behaelterPipe: BehaelterPipe = null;
    herstellerService: HerstellerService = null;
    herstellerPipe: HerstellerPipe = null;
    inventurService: InventurService = null;

    CRUDItemAvailableCols: any[] = null;

    constructor(
        @Inject(forwardRef(() => AppComponent)) public _app: AppComponent,
        private _crudItemService: InventurService,
        private _injector: Injector
    ) {
        super(_app, _injector);
        this.crudItemService = _crudItemService;

        this.behaelterService = _injector.get(BehaelterService);
        this.behaelterPipe = new BehaelterPipe(this.behaelterService);
        this.herstellerService = _injector.get(HerstellerService);
        this.herstellerPipe = new HerstellerPipe(this.herstellerService);
        this.inventurService = _injector.get(InventurService);

        this.CRUDItemAvailableCols = [
            {
                field: 'rueckgemeldet',
                header: this.translate.instant('Rückmelde-Datum', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "betweenMinMax",
                order: 2,
                showByDefault: true,
                customPipe: {
                    pipe: this.datumOhneZeitPipe,
                    args: ['/noUTC']
                }
            },
            {
                field: 'behaeltergroesse', // kg
                header: this.translate.instant('Behältergröße', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "contains",
                order: 4,
                showByDefault: true
            },
            {
                field: 'behaelterNummer',
                header: this.translate.instant('Behälter-Nummer', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "contains",
                order: 6,
                showByDefault: true
            },
            {
                field: 'inventurdatum',
                header: this.translate.instant('Inventurdatum', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "betweenMinMax",
                order: 10,
                showByDefault: false,
                customPipe: { 
                  pipe: this.datumOhneZeitPipe, 
                  args: ['/noUTC']
                }
            },
            {
                field: 'zustand',
                header: this.translate.instant('Zustand', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "contains",
                order: 30,
                showByDefault: true
            },
            {
                field: 'bemerkung',
                header: this.translate.instant('Bemerkung', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "contains",
                order: 40,
                showByDefault: true
            },
            {
                field: 'dienstleisterId',
                header: this.translate.instant('Dienstleister', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
                order: 50,
                showByDefault: true,
                //selectFromValues: this.filterMultiSelects[field+'Options'], // wird beim initialisieren per filterMultiSelectBuildFilter() autom. gefüllt
                //selectFromInit: this.filterMultiSelects[field+'Init'],
                customPipe: { 
                  pipe: this.dienstleisterPipe, 
                  //args: []
                }
            },
            /* behaelterId: - async pipe ist hardcoded
            - filter zeigt noch id
            /*-> deaktiviert, man sieht ja eh die BehälterNr. */
            /*{
                field: 'behaelterId', // das ist der Behälter, der nachträglich bei Auslieferung eingetragen wird!
                header: this.translate.instant('Behälter', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "in", // siehe CRUDBasicList zu 'in'
                order: 60,
                showByDefault: true,
                //customPipe: this.behaelterPipe,  // async funktioniert über transformByCustomPipe() leider nicht -> hardcoded im HTML
                //customPipeAsync: true
                customPipe: { 
                    pipe: this.behaelterPipe, 
                    //args: []
                  }
            },*/
            {
                field: 'interneBehaelterNummer',
                header: this.translate.instant('Interne Behälter-Nummer', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "contains",
                order: 70,
                showByDefault: false,
            },
            {
                field: 'behaeltervolumen', // Liter
                header: this.translate.instant('Behältervolumen', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "contains",
                order: 100,
                showByDefault: true
            },
            {
                field: 'hersteller', // async pipe is hardcoded!!!!
                header: this.translate.instant('Hersteller', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "in", // siehe CRUDBasicList zu 'in'
                order: 110,
                showByDefault: true,
                //customPipe: this.behaelterPipe,  // async funktioniert über transformByCustomPipe() leider nicht -> hardcoded im HTML
                //customPipeAsync: true
                customPipe: { 
                    pipe: this.herstellerPipe, 
                    //args: []
                  }
            },
            {
                field: 'baujahr',
                header: this.translate.instant('Baujahr', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "betweenMinMax",
                order: 120,
                showByDefault: true,
                customPipe: { 
                    pipe: this.datumOhneZeitPipe, 
                    args: ['/noUTC']
                    //pipe: this.datumPipe,
                    //args: 'monthAndYear'
                  }
            },
            {
                field: 'tankfarbe',
                header: this.translate.instant('Tankfarbe', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "contains",
                order: 130,
                showByDefault: true
            },
            {
                field: 'lagerungsart',
                header: this.translate.instant('Lagerungsart', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "contains",
                order: 140,
                showByDefault: true
            },
            {
                field: 'anlagenart',
                header: this.translate.instant('Anlagenart', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "contains",
                order: 150,
                showByDefault: false
            },
            {
                field: 'tUEVDatum',
                header: this.translate.instant('TÜV-Datum', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "betweenMinMax",
                order: 160,
                showByDefault: false,
                customPipe: { 
                    pipe: this.datumOhneZeitPipe, 
                    args: ['/noUTC']
                  }
            },
            {
                field: 'letzteBewegung',
                header: this.translate.instant('Letzte Bewegung', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "betweenMinMax",
                order: 170,
                showByDefault: true,
                customPipe: { 
                    pipe: this.datumOhneZeitPipe, 
                    args: ['/noUTC']
                  }
            },

            {
                field: 'faelligkeit',
                header: this.translate.instant('Fälligkeit', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "betweenMinMax",
                order: 220,
                showByDefault: true,
                customPipe: {
                    pipe: this.datumOhneZeitPipe,
                    args: ['/noUTC']
                }
            },
            {
                field: 'letzteInnerePruefung',
                header: this.translate.instant('Letzte Innere Prüfung', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "betweenMinMax",
                order: 230,
                showByDefault: true,
                customPipe: {
                    pipe: this.datumOhneZeitPipe,
                    args: ['/noUTC']
                }
            },
            {
                field: 'letzteAeusserePruefung',
                header: this.translate.instant('Letzte Äussere Prüfung', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "betweenMinMax",
                order: 240,
                showByDefault: true,
                customPipe: {
                    pipe: this.datumOhneZeitPipe,
                    args: ['/noUTC']
                }
            },
            {
                field: 'umbauNummer',
                header: this.translate.instant('Umbau Nummer', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "contains",
                order: 250,
                showByDefault: true
            },
            {
                field: 'umbauBaujahr',
                header: this.translate.instant('Umbau Baujahr', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "betweenMinMax",
                order: 260,
                showByDefault: true,
                customPipe: {
                    pipe: this.datumOhneZeitPipe, 
                    args: ['/noUTC']
                    //pipe: this.datumPipe,
                    //args: 'monthAndYear'
                }
            },
            {
                field: 'umbauHersteller',
                header: this.translate.instant('Umbau Hersteller', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "in", // siehe CRUDBasicList zu 'in'
                order: 270,
                showByDefault: true,
                //customPipe: this.behaelterPipe,  // async funktioniert über transformByCustomPipe() leider nicht -> hardcoded im HTML
                //customPipeAsync: true
                customPipe: {
                    pipe: this.herstellerPipe,
                    //args: []
                }
            },
            {
                field: 'vorhanden',
                header: this.translate.instant('Vorhanden', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
                order: 280,
                showByDefault: true,
                nullable: true
            },
            {
                field: 'verfuegbarkeitsstatus',
                header: this.translate.instant('Verfügbarkeitsstatus', true), // siehe XXX: wird noch überschrieben 
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
                order: 290,
                showByDefault: true
            },
            {
                field: 'nrVersorgungsunternehmen',
                header: this.translate.instant('Versorgungsunternehmen', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "contains",
                order: 300,
                showByDefault: true
            },
            {
                field: 'behaelterkennzeichen_1',
                header: this.translate.instant('Behälterkennzeichen 1', true), // siehe XXX: wird noch überschrieben
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
                order: 310,
                showByDefault: true,
                nullable: true
            },
            {
                field: 'behaelterkennzeichen_2',
                header: this.translate.instant('Behälterkennzeichen 2', true), // siehe XXX: wird noch überschrieben
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
                order: 320,
                showByDefault: true,
                nullable: true
            },
            {
                field: 'behaelterkennzeichen_3',
                header: this.translate.instant('Behälterkennzeichen 3', true), // siehe XXX: wird noch überschrieben
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
                order: 330,
                showByDefault: true,
                nullable: true
            },
            {
                field: 'behaelterkennzeichen_4',
                header: this.translate.instant('Behälterkennzeichen 4', true), // siehe XXX: wird noch überschrieben
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
                order: 340,
                showByDefault: true,
                nullable: true
            },
            {
                field: 'behaelterkennzeichen_5',
                header: this.translate.instant('Behälterkennzeichen 5', true), // siehe XXX: wird noch überschrieben
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
                order: 350,
                showByDefault: true,
                nullable: true
            },
            {
                field: 'behaelterkennzeichen_6',
                header: this.translate.instant('Behälterkennzeichen 6', true), // siehe XXX: wird noch überschrieben
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
                order: 360,
                showByDefault: true,
                nullable: true
            },
            {
                field: 'behaelterkennzeichen_7',
                header: this.translate.instant('Behälterkennzeichen 7', true), // siehe XXX: wird noch überschrieben
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
                order: 360,
                showByDefault: true,
                nullable: true
            },
            {
                field: 'behaelterkennzeichen_8',
                header: this.translate.instant('Behälterkennzeichen 8', true), // siehe XXX: wird noch überschrieben
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
                order: 360,
                showByDefault: true,
                nullable: true
            },
            /*{
                field: 'createdBy',
                header: this.translate.instant('CreatedBy', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "contains",
                order: 240,
                showByDefault: false
            },
            {
                field: 'created',
                header: this.translate.instant('Created', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "contains",
                order: 250,
                showByDefault: false
            },
            {
                field: 'modifiedBy',
                header: this.translate.instant('ModifiedBy', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "contains",
                order: 260,
                showByDefault: false
            },
            {
                field: 'modified',
                header: this.translate.instant('Modified', true),
                styleClass: 'columnText',
                sortable: true,
                filterMatchMode: "contains",
                order: 270,
                showByDefault: false
            }*/
        ];
        // alle gleich breit
        this.CRUDItemAvailableCols.forEach(element => {
            element.tdStyleClass = 'colWidthDefault';
            element.thStyleClass = 'colWidthDefault';
        });
    }

    ngOnInit() { // HTML Template Plugins
      super.ngOnInit();
      //this.app.pageTitle = this['pageTitle'];
        
      this.filterEnabled = true;
        
      this.app.setInventurComponent(this);
    }

      sortInventuren(arr: IInventur[]): IInventur[] {
        return arr.sort((a, b) => {
    
          // 1. Rueckgemeldet (null zuerst, dann absteigend)
          if (a.rueckgemeldet === null && b.rueckgemeldet !== null) return -1;
          if (a.rueckgemeldet !== null && b.rueckgemeldet === null) return 1;
          if (a.rueckgemeldet !== null && b.rueckgemeldet !== null) {
            const dateA = new Date(a.rueckgemeldet).getTime();
            const dateB = new Date(b.rueckgemeldet).getTime();
            if (dateA !== dateB) return dateB - dateA; // absteigend
          }
    
          // 2. Behaeltergroesse (numerisch, größte zuerst)
          const extractNumber = (s: string) => {
            if (!s) return 0;
            // alle Nicht-Ziffern entfernen, Komma/Punkt als Tausender oder Dezimal entfernen
            const num = s.replace(/[^\d,.-]/g, '').replace(',', '');
            return parseFloat(num) || 0;
          }
    
          const sizeA = extractNumber(a.behaeltergroesse);
          const sizeB = extractNumber(b.behaeltergroesse);
          if (sizeA !== sizeB) return sizeB - sizeA; // absteigend
    
          // 3. Behaelternummer alphanumerisch aufsteigend
          if (a.behaelterNummer < b.behaelterNummer) return -1;
          if (a.behaelterNummer > b.behaelterNummer) return 1;
    
          return 0; // identisch
        });
      }
    
    onCRUDItemsRetrieved(CRUDItems: /*ITitel*/any[], pagination: /*IPagination*/any) {
        CRUDItems = this.sortInventuren(CRUDItems);

        // Baujahr zu echtem Datum machen, sonst funktioniert MM/YYYY Pipe nicht
        /*CRUDItems.forEach(CRUDItem => {
            if (CRUDItem.baujahr != null) CRUDItem.baujahr = new Date(CRUDItem.baujahr);
            if (CRUDItem.umbauBaujahr != null) CRUDItem.umbauBaujahr = new Date(CRUDItem.umbauBaujahr);
        });
        console.log("InventurList.onCRUDItemsRetrieved() CRUDItems:", CRUDItems);*/

        // multiSelectFilter bestücken
        if(CRUDItems != null) {
          this.CRUDItemAvailableCols.filter(f => f.filterMatchMode == 'in').forEach(element => {
            switch(element.field) {
                case "dienstleisterId":
                    // Darf der User alle Dienstleister? - Falls Nein -> Multiselect schon nur damit bestücken
                    let filteredPseudoCRUDItems: IInventur[] = [];
                    if (this.app.topbarComponent.isDienstleisterAuswahlAvailable()) {
                        if (this.app.filterDienstleisterSelected != null && this.app.filterDienstleisterSelected.length > 0) {
                            this.app.filterDienstleisterSelected.forEach(dienstleister => {
                                console.log("inventur.onCRUDItemsRetrieved() pseudo dienstleister CRUDItem: dienstleister:", dienstleister);
                                let pseudoCRUDItem = this.inventurService.initializeInventur();
                                pseudoCRUDItem.dienstleisterId = dienstleister.id;
                                filteredPseudoCRUDItems.push(pseudoCRUDItem);
                            });
                        }
                        else { // Es gibt eine Auswahl, aber er hat Nichts ausgewählt -> Multiselect bleibt leer!
                            console.log("inventur.onCRUDItemsRetrieved() pseudo dienstleister - Auswahl ist leer. Multiselect = leer"); 
                        }
                    }
                    else { // Es gibt keine Auswahl! -> Dienstleister vom Benutzer nehmen
                        console.log("inventur.onCRUDItemsRetrieved() pseudo dienstleister - Es gibt keine Auswahl. Nur Dienstleister des Benutzers:", this.app.benutzer.dienstleister);
                        let pseudoCRUDItem = this.inventurService.initializeInventur();
                        pseudoCRUDItem.dienstleisterId = this.app.benutzer.dienstleisterId; // Benutzer ist aufgrund app.initCompleted schon geladen
                        filteredPseudoCRUDItems.push(pseudoCRUDItem);

                        // dann aber auch die Daten entspr. filtern!
                        CRUDItems = CRUDItems.filter(f => f.dienstleisterId == this.app.benutzer.dienstleisterId);
                    }
                    this.filterMultiSelectBuildFilter(element.field, /*CRUDItems*/filteredPseudoCRUDItems, element.field, element.field, this.dienstleisterPipe, false);
                   // den label lesbar machen:
                   //this.filterMultiSelects[element.field+'Options'].forEach(element => {
                   //  element.label = this.dienstleisterPipe.transform(element.label, null);
                   //});
                   break;
                case "hersteller":
                  this.filterMultiSelectBuildFilter(element.field, CRUDItems, element.field, element.field, this.herstellerPipe, true);
                  break;
                //case "__behaelterId":
                //  this.filterMultiSelectBuildFilter(element.field, CRUDItems, element.field, element.field, this.behaelterPipe, true);
                //  break;
              default: 
                  this.filterMultiSelectBuildFilter(element.field, CRUDItems, element.field, element.field, null, false);
                  break;
            }
          });
        }
              
        super.onCRUDItemsRetrieved(CRUDItems, pagination);
    }
  
    /*selectCRUDItem(CRUDItem: any) { // Overwrite zum CRUDBasic Standard // AM Parent-ChildTab-CRUD
        console.log("InventurList.selectCRUDItem() selectedCrudItem:", this.selectedCrudItem);
        console.log("InventurList.selectCRUDItem() CRUDItem:", CRUDItem);
    }*/

    clickTR(CRUDItem: /*ITitel*/any) {
        console.log("InventurList.clickTR() CRUDItem:", CRUDItem);
        super.selectCRUDItem(CRUDItem);
    }
 
    sizeTable(forceListRedraw?: boolean) { // Overwrite zum CRUDBasic Standard 
        this.scrollHeight = "flex";
    }

    ngOnDestroy(): void {
        console.log("inventur.ngOnDestroy()");
    
        try {
            this.app.setInventurComponent(null);
        }
        catch(e) {
          console.log("inventur.ngOnDestroy() error:", e);
        }
        
      } 
}
